import BpkLink from '@skyscanner/backpack-web/bpk-component-link';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { I18nService } from '@shared/types/i18n';

import STYLES from '../RatingStatement.module.scss';

import FormattedMessage from '@shared/ui/components/i18n/FormattedMessage';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

const StatementContent = ({ i18n }: { i18n: I18nService }) => (
  <>
    <BpkText tagName="p" className={cls('RatingStatement__text')}>
      {i18n.translate('rating_explaination_part1')}
    </BpkText>
    <BpkText tagName="p" className={cls('RatingStatement__text')}>
      <FormattedMessage
        label="rating_explaination_part2"
        data={{
          link: {
            pair: '/link',
            // eslint-disable-next-line react/no-unstable-nested-components
            format: (text: string) => (
              <>
                {' '}
                <BpkLink
                  href="https://www.skyscanner.net/media/how-skyscanner-works"
                  target="_blank"
                >
                  {text}
                </BpkLink>
              </>
            ),
          },
        }}
      />
    </BpkText>
  </>
);

export default withI18n(StatementContent);
